<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="chapterTitle"><a href="#/toc01#chap_05" id="chap05">WHAT ARE ATOMS?</a></p>
<p class="chapterAuthor">Marcus Chown</p>
<p class="subhead1">author of books about space and the universe</p>
<p class="image"><img alt="image" src="images/5_1.jpg"/></p>
<p class="image"><img alt="image" src="images/5_2.jpg"/></p>
<p class="para"> </p>
<p class="para"> </p>
<p class="paraNoIndent">Atoms are the building blocks out of which everything is made: you, me, trees, even the air we breathe. You cannot see atoms because they are very small. It would take ten million laid end to end to stretch across the dot of the exclamation mark at the end of this sentence!</p>
<p class="para">But if you could see an atom, you would notice something very odd indeed. They are not made of much at all. In fact, they are pretty much all empty space.</p>
<p class="para">At the centre of an atom is a tiny speck of matter called a nucleus. Circling it, like planets around the Sun, are even tinier specks of matter known as electrons. But in between the nucleus and the electrons is a lot of empty space. It means that you and I – since we are made of atoms – are mostly empty space.</p>
<p class="para">In fact, there is so much empty space inside atoms that if you were to squeeze out all the empty space from all the atoms in all the people in the world, they would fit in the volume of a sugar cube. Imagine. The whole human race squeezed down to the size of a sugar cube. Mind you, it would be a very, very heavy sugar cube!</p>
<p class="para">One more thing about atoms. They come in ninety-two different types (plus a few kinds that do not exist in nature but that scientists have made). And, just like if you put together different combinations of Lego bricks, you can make a house or a dog or a boat, atoms go together in different combinations to make a rose or a tree or a newborn baby. All of us are combinations of atoms. We are all different from each other because we are all different combinations of atoms.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap05.vue?3e6917f0